import { Stack } from "@mui/material";
import { LinksIcon } from "../../images";
import { Link } from "react-router-dom";

type Props = {
  url: string;
};

export const LinkListItem = ({ url }: Props) => {
  return (
    <Stack direction="row" alignItems="center" gap="10px">
      <LinksIcon />
      <Link to={url} target="_blank" style={{ color: "#0069C4" }}>
        {url.length > 30 ? `${url.substring(0, 30)}...` : url}
      </Link>
    </Stack>
  );
};
